module.exports = __webpack_public_path__ + "b9108e115d0c9ad4f98bb97272f49bb3.svg";